import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK, {LoadingAction, LoadChallengeCodeAction} from "mindsets-js-sdk";

import PDFViewer from '../common/PDFViewer';
import GeneralError from "../pages/GeneralError";
import useAuth from "../hooks/useAuth";

export default function () {
    useAuth(true);

    const params = useParams();
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const challenge_code = useSelector(state => state.challenge_code);
    const [failed, setFailed] = useState(false);
    const [message, setMessage] = useState('Challenge not found.');
    const [data, setData] = useState(null);

    function renderError() {
        if (failed === true) {
            return <GeneralError content={message}/>;
        }

        return null;
    }

    function renderContent() {
        if (data) {
            return (
                <PDFViewer
                    url={data}
                    fileName={`${challenge_code.latest_challenge_version_name} ${params.type}.pdf`}/>
            );
        }

        return null;
    }

    useEffect(() => {
        Promise.resolve()
            .then(() => dispatch(LoadingAction(true, 'Loading ...')))
            .then(() => dispatch(LoadChallengeCodeAction(params.challenge_code, {'selectors[0]': 'latest_challenge_version_name'})))
            .then(() => MindsetsJsSDK().API.get(`challenge_resources/pdf`, {
                buffer: true,
                challenge_code: params.challenge_code,
                type: params.type
            }))
            .then(buffer => setData(buffer))
            .catch(error => {
                setMessage(error);
                setFailed(true);
            })
            .then(() => dispatch(LoadingAction(false)));
    }, []);

    if (!challenge_code || !me) {
        return null;
    }

    return (
        <>
            {renderError()}
            {renderContent()}
        </>
    );
}